import React from 'react';
import { createToast, Toast, ToastType } from 'components/core';
type props = {
  toastMessage: string;
  toastType?: ToastType;
  role?: 'status' | 'alert';
};

const createStudyToast = ({
  toastMessage,
  toastType = 'success',
  role,
}: props) => {
  createToast(
    <Toast type={toastType} role={role}>
      {toastMessage}
    </Toast>
  );
};

export default createStudyToast;
